<template>
    <div class="dept-container">
        <el-card shadow="never" class="noBorder">
            <template #header>
                <div class="card-header">
                    <el-button type="primary" :icon="Plus" @click="onAddClick()" v-permission="['base:post:add']">添加</el-button>
                    <el-button :icon="Download" @click="importsVisible = true" v-permission="['base:post:import']">
                        导入
                    </el-button>
                    <el-button :icon="Upload" @click="handleExport" v-permission="['base:post:export']">导出</el-button>
                    <el-button :icon="DCaret" @click="handleSort" v-permission="['base:post:sort']">一键排序</el-button>
                </div>
            </template>
            <el-table :data="table_data" border style="width: 100%" overflow-y:auto>
                <el-table-column type="index" label="序号" width="60"></el-table-column>
                <el-table-column prop="code" label="岗位编码"></el-table-column>
                <el-table-column prop="name" label="岗位名称"></el-table-column>
                <el-table-column prop="status" label="状态" width="80">
                    <template #default="{ row }">
                        <el-switch
                            v-model="row.status"
                            :active-value="1"
                            :inactive-value="0"
                            @change="(val) => handleStatus(val, row)"
                            style="--el-switch-on-color: #13ce66"
                        />
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" sortable width="180"></el-table-column>
                <el-table-column prop="list_order" label="岗位排序" width="130">
                    <template #default="scope">
                        <el-input-number
                            style="width: 100px"
                            type="number"
                            v-model="scope.row.list_order"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                            size="small"
                        />
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template #default="{ row }">
                        <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['base:post:edit']">
                            编辑
                        </el-button>
                        <el-button
                            type="primary"
                            link
                            :icon="Delete"
                            @click="onRemoveClick(row)"
                            v-permission="['base:post:remove']"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
                class="pagination"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="page"
                :page-sizes="[10, 20, 50]"
                :page-size="size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            ></el-pagination>
        </el-card>

        <forms-dialog
            v-model="formDialogVisible"
            :isForm="isForm"
            :formId="selectFormId"
            @updateForm="getTableData"
        ></forms-dialog>
        <ImportsForm v-model="importsVisible" @updateForm="getTableData" menuCode="post" />
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
import FormsDialog from './components/forms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { batchDisable, batchEnable, batchSort, delPost, getPostList } from '@/api/post.js'
import ImportsForm from '@/components/ImportsForm.vue'
import { DCaret, Delete, Download, Edit, Plus, Upload } from '@element-plus/icons'
// ElMessage

// 数据相关
const table_data = ref([{}])
const total = ref(0)
const page = ref(1)
const size = ref(10)
// 获取数据的方法
const getTableData = async () => {
    const result = await getPostList({
        page: page.value,
        page_size: size.value
    })
    table_data.value = result.lists
    total.value = result.total
}

// 分页相关
/**
 * size 改变触发
 */
const handleSizeChange = (currentSize) => {
    size.value = currentSize
    getTableData()
}

/**
 * 页码改变触发
 */
const handleCurrentChange = (currentPage) => {
    page.value = currentPage
    getTableData()
}

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectFormId = ref('') // 点中的模块id
// 保证每次打开重新获取用户角色数据
watch(formDialogVisible, (val) => {
    if (!val) selectFormId.value = ''
})
// 查看
// const onShowClick = (row) => {
//     selectFormId.value = row.id
//     isForm.value = false
//     formDialogVisible.value = true
// }
// 编辑
const onEditClick = (row) => {
    selectFormId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectFormId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delPost(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getTableData()
        })
        .catch(() => {})
}

// 导入
const importsVisible = ref(false)

// 导出
const handleExport = () => {
    ElMessageBox.confirm('是否确认导出岗位列表', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            const data = await getPostList({ export: 1 })
            window.open(data.data)
            ElMessage({
                type: 'success',
                message: '导出成功'
            })
        })
        .catch(() => {})
}

// 修改岗位状态
const handleStatus = (val, row) => {
    if (!row.id) return
    const msg = val ? '启用' : '停用'
    ElMessageBox.confirm(`是否确认要"${msg}""${row.name}"角色吗？`, '系统提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            if (val) {
                await batchEnable([row.id])
            } else {
                await batchDisable([row.id])
            }
            ElMessage({
                type: 'success',
                message: msg + '成功'
            })
        })
        .catch(() => {
            row.status = val ? 0 : 1
        })
}

const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getTableData()
}

// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getTableData()
})
</script>

<style lang="scss" scoped></style>
